import type { UseTranslationResponse } from "react-i18next";

import {
  errors as errorsKeys,
  type BulkBookingCreateConflict,
  type IBookingPollingError,
  type IBulkBookingsPanelLabelKeys,
  type ITranslatableItem,
} from "@ryde/shared";

interface IProgressTitleResolveArguments {
  isLoading: boolean;
  isPreview: boolean;
  errors: IBookingPollingError[] | null | undefined;
  translatableErrors?: ITranslatableItem[] | null | undefined;
  conflictErrors: BulkBookingCreateConflict[] | null | undefined;
  isBulkBookingSetFinish: boolean;
  isBulkBookingValidationFinish: boolean;
  totalCount?: number;
  current?: number;
  labelKeys: IBulkBookingsPanelLabelKeys;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: UseTranslationResponse<any, any>["t"];
}

export const progressTitleResolve = ({
  isBulkBookingSetFinish,
  isBulkBookingValidationFinish,
  isPreview,
  isLoading,
  errors,
  conflictErrors,
  current,
  labelKeys,
  t,
}: IProgressTitleResolveArguments): string => {
  switch (true) {
    case isBulkBookingSetFinish:
      return t(labelKeys.progressFinished);
    case isBulkBookingValidationFinish:
      return t("rideProduction.validationFinished");
    case isPreview && !!conflictErrors?.length:
      return t(errorsKeys.booking.processingBookingsHasConflicts, {
        succeededCount: current ? current + 1 - conflictErrors.length : 0,
        conflictedCount: conflictErrors.length,
      });
    case isPreview && !conflictErrors?.length:
      return t(errorsKeys.booking.processingBookings, {
        succeededCount: current,
      });
    case !isPreview && !!errors?.length:
      return t(labelKeys.progressError);
    case isPreview && isLoading:
      return t("rideProduction.validatingBookings");
    default:
      return t(labelKeys.progressRunning);
  }
};
